import React, { Fragment, Component } from "react";

import Slider from "react-slick";

import conference from "../../../assets/utils/images/top-img.png";
import live_call from "../../../assets/utils/images/live-calls.png";
import video_api from "../../../assets/utils/images/video-api.png";
import video_kiosk from "../../../assets/utils/images/video-kiosk.png";
import { withRouter } from "react-router";
import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap";
import { auth } from "../../../Auth/Firebase";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: "",
      email: "",
      email_sent: false,
      disable_input: false
    }

    this.sendResetEmail = this.sendResetEmail.bind(this);
  }

  sendResetEmail(email) {
    if(!email.trim()){
      this.setState({message: "Email cannot be empty."});
      return;
    }
    this.setState({disable_input: true});
    auth.sendPasswordResetEmail(email)
    .then(() => {
      this.setState({email_sent: true, message: ""});
      this.setState({disable_input: false});
      // setTimeout(() => {this.setState({email_sent: false})}, 3000);
    })
    .catch((error) => {
      this.setState({message: error.message});
      this.setState({disable_input: false});
    });
  }

  handleEnterPress = (event, callback) => {
    if(event.key === 'Enter'){
      callback();
    }
  }

  render() {
    let settings = {
      dots: true,
      infinite: true,
      speed: 500,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      initialSlide: 0,
      autoplay: true,
      adaptiveHeight: true,
    };
    return (
      <Fragment>
        <div className="login-main">
        <div className="login-video">
  <video
    autoPlay
    loop
    muted
    className="sample-video h-100 no-gutters"
  >
    <source
      src="https://client-static.saleassist.ai/74c28198-7762-40d3-8925-5cc00dc99e98/hb-opt.mp4"
      type="video/mp4"
    />
    Your browser does not support the video tag.
  </video>
</div>
        <div className="login-form h-100">
          <Row className="h-100 no-gutters">
            {/* <Col lg="4" className="d-none d-lg-block">
              <div className="slider-dark">
                <Slider {...settings}>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-premium-light">
                    <div className="slide-img-bg opacity-1"
                      style={{
                        backgroundImage: "url(" + conference + ")",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat"
                      }}/>
                    <div className="slider-content">
                      <h3>Secure video conferencing</h3>
                      <p>
                        Secure and safe environment customized with your company's brand logo and theme.
                      </p>
                    </div>
                  </div>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-premium-light">
                    <div className="slide-img-bg opacity-1"
                      style={{
                        backgroundImage: "url(" + video_api + ")",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat"
                      }}/>
                    <div className="slider-content">
                      <h3>API driven. Build. Experience.</h3>
                      <p>
                        SaleAssist can be integrated into any of your business process, e.g integration with ERP or a Ticketing system. We have Transactional Video call APIs by which you can have on-demand video call generated, programatically ! Whether you are an enterprise or a startup, we have solutions for all scale. These are REST APIs and have simple integration.
                      </p>
                    </div>
                  </div>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-premium-light">
                    <div className="slide-img-bg opacity-1"
                      style={{
                        backgroundImage: "url(" + live_call + ")",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat"
                      }}/>
                    <div className="slider-content">
                      <h3>Live Calls</h3>
                      <p>
                        Live Call gets plugged in to your application and enables direct video calling. Let it be website or a custom application, with just inserting few lines of code , Live Call makes your frontend video call enabled. It’s that simple ! Features include multiple agent management, reports & analytics and did we mention your first 100 Video calls are on us!
                      </p>
                    </div>
                  </div>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-premium-light">
                    <div className="slide-img-bg opacity-1"
                      style={{
                        backgroundImage: "url(" + video_kiosk + ")",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat"
                      }}/>
                    <div className="slider-content">
                      <h3>Video Kiosk</h3>
                      <p>
                        In times of social distancing, video kiosk offers immense value to engage & interact with your walk in customers. Have live video conversation with visitors while your customer representatives may be remotely working. Did we mention earlier that all conversations get recorded for quality purposes
                      </p>
                    </div>
                  </div>
                </Slider>
              </div>
            </Col> */}
            <Col
              className="h-100 d-flex bg-white justify-content-center align-items-center" style={{textAlign: "center"}}>
              <Col  className="mx-auto app-login-box">
              {/* <div className="app-block-logo" /> */}
              <div> <img
                src="https://client-static.saleassist.ai/74c28198-7762-40d3-8925-5cc00dc99e98/sa-new-Logo.png"
                alt="SaleAssist Logo"
                style={{ width: "200px",marginRight:"25px"}} // Set size and margin for logo
              />
              </div>
              <div style={{ color: "grey",
                      backgroundColor: "white",
                      border: "none",
                      borderRadius: "0.25rem",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",  // Adds a subtle shadow for the card effect
                      padding: "10px 15px",  // Adds some padding to make it feel more like a card
                      backgroundSize: "70%",}}>
                <h4>
                  <div>Forgot your Password?</div>
                  <span>Use the form below to recover it.</span>
                </h4>
                <h6 className="mt-3 text-danger">
                  {this.state.message}
                </h6>
                <div>
                  {this.state.email_sent ? <h6 className="mt-3 text-success">
                    We have sent you an email with a link to reset your password. Please follow the instruction in the email.
                    <br />
                    <br />
                    <a href="#" onClick={(e) => {e.preventDefault(); this.props.history.push('/auth/login')}} className="text-primary">
                      Sign in
                    </a>
                  </h6> : <Form onSubmit={(e) => e.preventDefault()}>
                    <Row form>
                      <Col md={12}>
                        <FormGroup>
                          <Label for="exampleEmail">Email</Label>
                          <Input type="email" name="email" id="exampleEmail" placeholder="Email here..." 
                            onChange={(e) => {this.setState({email: e.target.value})}} value={this.state.email} 
                            onKeyPress={(e) => this.handleEnterPress(e, () => {this.sendResetEmail(this.state.email)})}
                            disabled={this.state.disable_input}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className="mt-4 d-flex align-items-center">
                      <h6 className="mb-0">
                        <a href="#" onClick={(e) => {e.preventDefault(); this.props.history.push('/auth/login')}} className="text-primary">
                          Sign in existing account
                        </a>
                      </h6>
                      <div className="ml-auto">
                        <Button className="login-btn" size="lg" disabled={this.state.disable_input} onClick={(e) => {e.preventDefault(); this.sendResetEmail(this.state.email)}}>
                          Recover Password
                        </Button>
                      </div>
                    </div>
                  </Form>}
                </div>
                </div>
              </Col>
            </Col>
          </Row>
        </div>
        </div>
        
      </Fragment>
    );
  }
}

export default withRouter(ForgotPassword);